export const makerUser = {
  isMacChrome: () => {
    if (navigator.userAgent.includes('Macintosh') && navigator.userAgent.includes('Chrome')) {
      return true;
    } else {
      return false;
    }
  },
};
